/* TinyOops feature icons + section photos (5.9.2026, v9)
   1) Distinct line icon per claim in the scrolling feature strips.
   2) Own photo for each card in "The stuff that didn't work" (fail-*.jpg in Shopify Files).
   3) Layer exploded-view photo in "Why it works" (feat-layers.jpg).
   4) Supplier photos on the first four Features cards.
   5) Seven lifestyle photos in the "Everyday life" strip (life-1.jpg … life-7.jpg), square cards. */
(function () {
  'use strict';
  var S = 'width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:none;display:block"';
  var ICONS = {
    soak:  '<svg ' + S + '><path d="M12 3c3.5 4.3 5.5 7 5.5 9.2a5.5 5.5 0 0 1-11 0C6.5 10 8.5 7.3 12 3z"/></svg>',
    odor:  '<svg ' + S + '><path d="M3 8h9a3 3 0 1 0-3-3"/><path d="M3 13h12a3 3 0 1 1-3 3"/><path d="M3 18h7"/></svg>',
    grip:  '<svg ' + S + '><rect x="3" y="6" width="18" height="12" rx="3"/><path d="M8 10.5h.01M12 10.5h.01M16 10.5h.01M8 14h.01M12 14h.01M16 14h.01"/></svg>',
    wash:  '<svg ' + S + '><rect x="4" y="3" width="16" height="18" rx="3"/><path d="M4 8h16"/><circle cx="12" cy="14.5" r="3.6"/></svg>',
    chew:  '<svg ' + S + '><path d="M12 3l7.5 3v5.2c0 4.7-3.1 8.3-7.5 10.3-4.4-2-7.5-5.6-7.5-10.3V6z"/><path d="M9.2 12.2l1.9 1.9 3.8-3.9"/></svg>',
    cost:  '<svg ' + S + '><circle cx="12" cy="12" r="9"/><path d="M5.6 5.6l12.8 12.8"/><path d="M14.8 9.3A2.7 2.7 0 0 0 12.3 8c-1.6 0-2.8.9-2.8 2.1"/><path d="M9.4 14.5c.3 1 1.4 1.6 2.8 1.6 1.5 0 2.7-.8 2.7-2"/></svg>'
  };
  function pick(t) {
    t = t.toLowerCase();
    if (/soak|absorb|8 sec/.test(t)) return ICONS.soak;
    if (/odor|odour|smell/.test(t)) return ICONS.odor;
    if (/slip|grip/.test(t)) return ICONS.grip;
    if (/wash/.test(t)) return ICONS.wash;
    if (/chew|edge|claw/.test(t)) return ICONS.chew;
    if (/cost|monthly|refill|price/.test(t)) return ICONS.cost;
    return null;
  }
  var CDN = 'https://cdn.shopify.com/s/files/1/1013/4418/2646/files/';
  var CARDS = [
    [/disposable pads/i,     'fail-disposable.jpg', 'A stack of disposable puppy pads', 'cover'],
    [/old towels/i,          'fail-towels.jpg',     'Old towels in a bathtub', 'cover'],
    [/newspaper/i,           'fail-newspaper.jpg',  'Shredded newspaper on a carpet', 'cover'],
    [/plastic trays/i,       'fail-tray.jpg',       'A plastic dog tray on the floor', 'cover'],
    [/cheap washable/i,      'fail-cheapmat.jpg',   'A cheap washable mat curling at the corner', 'cover'],
    [/quilted 4-layer core/i,'feat-core.jpg',       'The four layers of the mat shown separately', 'contain'],
    [/non-slip base/i,       'feat-nonslip.jpg',    'The anti-skid underside and the floors it grips', 'contain'],
    [/double-stitched/i,     'feat-durability.jpg', 'A shredded disposable pad next to an intact TinyOops mat', 'cover'],
    [/odor lock/i,           'feat-scent.jpg',      'A dog sniffing the TinyOops mat on a wooden floor', 'cover']
  ];
  var LIFE = [
    ['life-1.jpg', 'A dachshund curled up asleep on the mat'],
    ['life-2.jpg', 'A beagle stepping off the mat after using it'],
    ['life-3.jpg', 'An older woman with her senior labrador'],
    ['life-4.jpg', 'A puppy greeting its owner beside the bed'],
    ['life-5.jpg', 'A French bulldog on the mat in a high-rise apartment'],
    ['life-6.jpg', 'A boxer standing on the mat by the wall'],
    ['life-7.jpg', 'A small dog sitting on the mat']
  ];
  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }

  function fillStrip() {
    var tracks = [].slice.call(document.querySelectorAll('.to-track'));
    var strip = tracks.filter(function (t) { return t.getAttribute('aria-label') !== 'Product photos'; })[0];
    if (!strip || strip.getAttribute('data-life') === '1') return !!strip;
    strip.setAttribute('data-life', '1');
    strip.innerHTML = '';
    LIFE.forEach(function (row) {
      var card = document.createElement('span');
      card.style.cssText = 'flex:none;width:min(230px,70vw);aspect-ratio:1/1;border:2px solid #26241F;border-radius:16px;overflow:hidden;display:block;scroll-snap-align:start;background:#FFFDF8';
      var im = document.createElement('img');
      im.src = CDN + row[0]; im.alt = row[1]; im.loading = 'lazy'; im.decoding = 'async';
      im.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block';
      card.appendChild(im);
      strip.appendChild(card);
    });
    strip.dispatchEvent(new Event('scroll'));
    return true;
  }

  ready(function () {
    document.querySelectorAll('[style*="50% 50% 50% 3px"]').forEach(function (dot) {
      var item = dot.parentElement;
      if (!item) return;
      var svg = pick(item.textContent || '');
      if (!svg) return;
      var span = document.createElement('span');
      span.style.cssText = 'flex:none;display:flex;align-items:center;color:#26241F';
      span.innerHTML = svg;
      dot.replaceWith(span);
    });

    document.querySelectorAll('h3').forEach(function (h) {
      var t = h.textContent || '';
      CARDS.forEach(function (row) {
        if (!row[0].test(t)) return;
        var card = h.parentElement;
        var img = card && card.querySelector('img');
        if (!img) return;
        img.src = CDN + row[1];
        img.alt = row[2];
        img.style.objectPosition = '50% 50%';
        if (row[3] === 'contain') {
          img.style.objectFit = 'contain';
          img.style.padding = '6px';
          if (img.parentElement) img.parentElement.style.background = '#FFFFFF';
        }
      });
    });

    var why = document.querySelector('#why');
    var layers = why && why.querySelector('img');
    if (layers) {
      layers.src = CDN + 'feat-layers.jpg';
      layers.alt = 'The four layers of the TinyOops mat, separated';
      layers.style.objectPosition = '50% 50%';
      if (layers.parentElement) layers.parentElement.style.background = '#BCD6E0';
    }

    /* the strip is built by tinyoops-extras.js; try now and again shortly after in case it is still being built */
    if (!fillStrip()) { setTimeout(fillStrip, 150); setTimeout(fillStrip, 800); }
  });
})();
